module.exports = __webpack_public_path__ + "img/icon_256x256.fce6fa8d.png";